import { ProductCategory } from "../../../constants/products";
import { PagingParameters } from "./paging";
import { CheckoutPricesResponse } from "./Payment";

// export enum ProductCategory {
//     TRANSPORTATION = "transportation",
//     TOOLS = "tools",
//     LEISURE = "leisure",
//     HOME = "home"
// }
/* export enum ProductCategory {
    TRANSPORTATION = "transportation",
    DEVICES = "devices",
    REALESTATE = "realestate",
    SERVICES = "services"
} */

export interface CreateProductModel {
    title: string;
    description: string;
    category: ProductCategory;
    untilActiveDate: Date;
    price: {
        hourly?: number;
        daily: number;
        monthly?: number;
        weekly?: number;
    };
    location: string;
    pictureIds: number[];
    paymentOptionCode: string;
    checkoutOverviewData: CheckoutPricesResponse;
    checkoutModel: ProductCheckoutModel
}

export interface UpdateProductModel {
    title?: string;
    description?: string;
    category?: ProductCategory;
    price?: {
        hourly?: number;
        daily?: number;
        monthly?: number;
        weekly?: number;
    };
    location?: string;
    pictureIds?: number[];
}

export enum CreateProductResponseType {
    REDIRECT_PAYMENT = "REDIRECT",
    CARD_PAYMENT = "CARD_PAYMENT",
    ORDER_CONFIRMED = "ORDER_CONFIRMED"
}

export interface CreateProductResponse {
    id: number;
    type: CreateProductResponseType;
    paymentUrl?: string; // client needs to pay for the listing
    clientSecret?: string // client secret needed for Stripe for the payment session
    visibleUntilDate?: Date;
    orderId?: number;
}

export interface ProductCheckoutModel {
    category?: ProductCategory,
    priceDay?: number,
    availableUntilDate?: Date,
    availableUntilWeeks?: number,
    boostLevel?: number,
    discountCode?: string,
    discountCodeId?: number;
    campaign1000?: boolean,
}

export interface PorductSearchFilters extends PagingParameters {
    startPrice?: number;
    endPrice?: number;
    title?: string;
    description?: string;
    location?: string;
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    endTime?: string;
    oneDayRentalDate?: Date;
    isOneDayRental?: boolean;
    category?: ProductCategory;
    userId?: number;
}

export interface ProductFilterContainerFilters {
    page: number;
    take: number;
    startPrice?: number;
    endPrice?: number;
    title?: string;
    description?: string;
    location?: string;
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    endTime?: string;
    oneDayRentalDate?: Date;
    isOneDayRental?: boolean;
    category?: ProductCategory;
}

// export interface ProductListResponse {
//     id: number;
//     defaultPictureUrl: string;
//     category: ProductCategory;
//     title: string;
//     description: string;
//     firstAvailableDate?: Date;
//     availableUntilDate?: Date;
//     dailyPrice: number;
//     location: string;
// }

export interface ProductAvailableDate {
    startDate: Date;
    endDate: Date;
}

export type DateIntervalModel = {
    startDate: Date;
    endDate: Date;
};

export interface PictureFileProduct {
    id: number;
    publicUrl: string;
    orderNr: number;
}

export interface ProfileProductResponse {
    id: number;
    name: string;
    picUrl: string;
    verified: boolean;
}

export interface ProductListResponse {
    id: number;
    defaultPictureUrl: string;
    category: ProductCategory;
    title: string;
    description: string;
    firstAvailableDate?: Date;
    availableUntilDate?: Date;
    dailyPrice: number;
    location: string;
    availableDates: ProductAvailableDate[];
    isHighlighted: boolean;
    hourlyPrice?: number;
    weeklyPrice?: number;
    monthlyPrice?: number;
    createdAtDate?: Date;
    userId: number;
    userProfileId: number;
    userProfile: ProfileProductResponse;
    pictures: PictureFileProduct[];
}

export interface UserProductsListResponse {
    id: number;
    title: string;
    category: ProductCategory;
    dailyPrice: number;
    visibleUntilDate: Date;
    isPaid: boolean;
    pictureUrl: string;
    isAvailableNow: boolean;
    location: string;
    createdAt: Date;
}

export interface ProductAvailabilityAndDateResponse {
    isAvailable: boolean;
    price: number
}

export interface ProductSubscription {
    id: number;
    amount: number;
    activeUntilDate: Date;
    paidAt?: Date;
}

export interface ProductEditResponse extends ProductListResponse {
    editedAtDate?: Date;
    highlightedUntilDate?: Date;
    productSubscription: ProductSubscription;
    checkoutOverviewData: CheckoutPricesResponse;
}

export enum ProductRemoveStatus {
    UPCOMING_RENTALS,
    SUCCESS
}

export interface ProductRemoveResponse {
    status: ProductRemoveStatus
}

export enum ProductPublicDetailResponseStatus {
    NOT_FOUND,
    EXPIRED
}
